export default {"src":"/_next/static/media/time_blue.53abe4f8.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};